/**
 * Application entry point
 */

// Load application styles
import 'styles/index.scss';

// ================================
// START APP HERE
// ================================
var config = require('./parts/config');
var missions = require('./parts/missions');
var planets = require('./parts/planets');

(function() {

    const SIZE_MULTIPLIER = 0.0085;
    const SIZE_MAX = 8;
    const HEAD_SIZE_MULTIPLIER = 0.027;
    const HEAD_SIZE_MAX = 28;

    let missionData;

    /* POLYFILLS */
    if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = function (callback, thisArg) {
            thisArg = thisArg || window;
            for (var i = 0; i < this.length; i++) {
                callback.call(thisArg, this[i], i, this);
            }
        };
    }
    /* END_POLYFILLS */

    function setMissionEvents() {
        document.querySelectorAll('[data-planet]').forEach(function (el) {
            el.addEventListener('click', function () {
                planets.setFocus(this.getAttribute('data-planet'), this.getAttribute('data-mission'));
                missions.displayInfo(this, missionData);
            });
        });
    }

    function setCourtesyInfo() {
        let cInfoEl = document.getElementById('ss-cr-info-data'),
            startR = cInfoEl.style.right;
        document.getElementById('ss-cr-info').addEventListener('click', function() {
            cInfoEl.style.right = 0;
        }, false);
        document.getElementById('ss-cr-info-close').addEventListener('click', function () {
            cInfoEl.style.right = startR;
        }, false);
    }

    function init() {

        let ssEl = document.getElementById('ss'),
            hEl = document.getElementById('ss-mori-header');

        window.addEventListener('load', function () {
            setSSSize();
        });

        window.addEventListener('resize', function () {
            //window size changes can cause the mission paths to get desynced with the planets
            //so just clear the path
            planets.clearRect();
            missions.buildMissionList();
            setSSSize();
            setMissionEvents();
        });

        function setSSSize() {
            //1000px 8.5px
            let size = ssEl.clientWidth,
                ssSize = size * SIZE_MULTIPLIER,
                hSize = size * HEAD_SIZE_MULTIPLIER;
            ssEl.style.fontSize = (ssSize < SIZE_MAX ? ssSize : SIZE_MAX) + 'px';
            hEl.style.fontSize = (hSize < HEAD_SIZE_MAX ? hSize : HEAD_SIZE_MAX) + 'px';
        }

        setSSSize();
        setCourtesyInfo();

        //to avoid the animation/css startup that happens, the display is hidden by default
        window.setTimeout(function() {
            let ssw = document.getElementById('ss-wrapper');
            //IE doesn't support multiple remove args, so do it one-by-one
            ssw.classList.remove('invisible');
            ssw.classList.remove('hide');
        }, 900);
    }

    document.addEventListener('DOMContentLoaded', function (event) {
        config.readJSON('assets/data/missions.json', function (data) {
            missionData = data;
            missions.initMissions(missionData);
            missions.buildMissionList();
            setMissionEvents();
        });

        //preloading the larger planet GIFs can help avoid load delays on click
        config.preloadImages();

        planets.init(missions);
        init();
    });

})();
